// extracted by mini-css-extract-plugin
module.exports = {"container":"PlaceholderPage_container__2Bkc2","main":"PlaceholderPage_main__1RNGl","text":"PlaceholderPage_text__1tJhP","logo":"PlaceholderPage_logo__2uLDn"};